import { Component, OnInit, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ListContent, Restaurant } from '../../core/models';
import { Product } from '../../core/models';
import { VendorMarketRowComponent } from './vendor-market-row/vendor-market-row.component';
import { ProductMarketRowItemComponent } from './product-market-row-item/product-market-row-item.component';

@Component({
    selector: 'app-base-market-row',
	standalone: true,
	imports: [VendorMarketRowComponent, ProductMarketRowItemComponent],
    templateUrl: './base-market-row.component.html',
    styleUrls: ['./base-market-row.component.css'],
})
export class BaseMarketRowComponent implements OnInit {

	@Input() items: Product[] | Restaurant[];
	@Input() displayOnMain?: boolean = false; //TODO: Should be seperated renamed to reflect feature toggles i.e. canAddToBasket or routeToMarketRestaurantPage

	constructor(public translate: TranslocoService) { }

	ngOnInit(): void {
	}

	getRowType(data) {
		data = data[0];
		if (data instanceof Restaurant) return "vendor";
		else if (data instanceof Product) return "product";
	}
}
